import React, {ReactNode} from "react";
import Box from "@material-ui/core/Box";
import ModalSectionHeader from "./ModalSectionHeader";

export type ModalSectionProps = {
  title?: string;
  children?: ReactNode;
  actionPanel?: ReactNode;
};

const ModalSection: React.FC<ModalSectionProps> = ({
  title,
  children,
  actionPanel,
}) => {
  return (
    <Box marginBottom={2}>
      <Box>
        {title && (
          <ModalSectionHeader title={title} actionPanel={actionPanel} />
        )}
      </Box>
      {children}
    </Box>
  );
};

export default ModalSection;
